module.exports = __webpack_public_path__ + "assets/img/certificate_demo_quiz.png";